function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#444",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.76 15.948l-.85 1.625a.5.5 0 01-.659.219L2.284 14.94A.5.5 0 012 14.489V11.51a.5.5 0 01.284-.45l5.967-2.853a.5.5 0 01.659.22l.85 1.624a.5.5 0 01-.228.683l-4.595 2.197v.136l4.595 2.197a.5.5 0 01.228.683zM19.24 10.052l.85-1.625a.5.5 0 01.659-.219l5.967 2.852a.5.5 0 01.284.451v2.978a.5.5 0 01-.284.45l-5.967 2.853a.5.5 0 01-.659-.22l-.85-1.624a.5.5 0 01.228-.683l4.595-2.197v-.136l-4.595-2.197a.5.5 0 01-.228-.683z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.891 3h1.924a.5.5 0 01.465.685l-7.155 18a.5.5 0 01-.464.315H9.737a.5.5 0 01-.465-.685l7.154-18A.5.5 0 0116.891 3z"
}));

function SvgIcCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25
  }, props), _ref);
}

export default SvgIcCode;